// extracted by mini-css-extract-plugin
export default {"layer":"ParallaxLayer_layer__sifb8","art":"ParallaxLayer_art__44q4H","drift":"ParallaxLayer_drift__I-9ac","bob":"ParallaxLayer_bob__HROXT","pulse":"ParallaxLayer_pulse__euXel"};